const type = process.env.NODE_ENV === 'development' ? 'dev' : 'prod'

const configs = {
  dev: {
    //baseURL: 'http://localhost:3000/v1'
    baseURL: 'https://sore-lime-mite-cape.cyclic.app/v1'
  },
  prod: {
    baseURL: 'https://sore-lime-mite-cape.cyclic.app/v1'
  }
}

const config = configs[type]

export default config